import { Navigate, Outlet } from "react-router-dom";
import { PAGE_LOGIN } from "~/constants/page";
import { useAuthenticationContext } from "~/providers/AuthenticationProvider";
import { Suspense } from "react";
import MikeLoading from "../loading/Loading";
const ProtectedRoute = () => {
  const { isAuthLoading, token } = useAuthenticationContext();

  if (isAuthLoading) {
    return <MikeLoading />;
  }

  if (!token) {
    return <Navigate to={PAGE_LOGIN} />;
  }

  return (
    <Suspense fallback={<MikeLoading />}>
      <Outlet />
    </Suspense>
  );
};

export default ProtectedRoute;
